module.exports = __webpack_public_path__ + "static/media/bus-icon.61045b2f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/suttonparkbus/bus-icon.svg
// module id = 869
// module chunks = 0